import {  VStack, Image } from '@chakra-ui/react'
import usdcImg from '../images/USDC_32.webp'
import {getAttribute} from '../lib/meta'

const NFTCard = (props) => {
    const level = parseInt(getAttribute(props,'Level'))
    const price = ' ' + (level * 150) + ' USDC'
    return (
        <div style={{width: 250, height: 390, display: 'inline-block', boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)', borderRadius: 10, padding: 0, margin: 7, textAlign: 'left', cursor: 'pointer'}} onClick={() => props.onClick(props)}>
            <VStack style={{height: '100%', textAlign: 'left'}} >
                <Image src={props.image} alt={props.name}/>
                <div style={{textAlign: 'left', width: '80%', fontSize: 14, fontWeight: 'bold'}}>{props.name}</div>
                <div style={{textAlign: 'left', width: '80%', fontSize: 13, fontWeight: 'bold'}}>Price: <img alt='price' src={usdcImg} style={{width: 15, height: 15, display: 'inline-block', position: 'relative', top: 3, marginLeft: 2, marginRight: 3}} /> 
                    <div style={{display: 'inline-block', fontWeight: 'normal', fontSize: 13, position: 'relative', top: 0}}>{price}</div>
                </div>
                
            </VStack>
        </div>
    )
}

export default NFTCard